<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "DAILY_ATTENDENACE" |
                    translate
                    | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                                                }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester"
                                                (change)="getBatches()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch" (change)="getBatchGroups()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <!-- <option value="202">{{ "static group" | translate | titlecase
                                                    }}
                                                </option> -->
                                                <option *ngFor="let field of batches" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "GROUP" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="group"(change)="getDateStatus()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                <!-- <option value="770">{{ "static group" | translate |
                                                    titlecase
                                                    }}</option> -->
                                                <option *ngFor="let field of groups" value="{{field.id}}">
                                                    {{(globals.lang == 'ar')? field.egroupNameAr :
                                                    field.egroupNameEn}} - ({{field.egroupCode}})</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.group.touched && searchForm.controls.group.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "DATE" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="date">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                <!-- <option value="770">{{ "static group" | translate |
                                                    titlecase
                                                    }}</option> -->
                                                <option *ngFor="let field of dateStatus" value="{{field.dateValue}}">
                                                    {{field.dateDescription}}</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.date.touched && searchForm.controls.date.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "STATUS" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="status">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}</option>
                                                <option value="COMPLETE">{{ "COMPLETE" | translate | titlecase
                                                    }}</option>
                                                <option value="PENDING">{{ "PENDING" | translate | titlecase
                                                    }}</option>
                                                <option value="PARTIAL">{{ "PARTIAL" | translate | titlecase
                                                    }}</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.status.touched && searchForm.controls.status.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div> -->
                                        <div class="col-md-6 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;" *ngIf="viewAvailDates">
                                            <button  class="btn btn-success"type="button"  
                                            data-toggle="modal" data-target="#ChronicDiseases">
                                                {{ "AVAILABLE_DATES" | translate | titlecase }} ({{ dateStatus.length }})</button>
                                        </div>

                                        
                                    </div>
                                </form>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row" *ngIf="!showLoader && students.length >= 1">
                    <div class="col-sm-1">
                        <button (click)="generateExcel()" class="btn" style="height:auto"><span
                                style="font-size: 2em; color: green;"><i
                                    class="fas fa-file-excel fa-sm"></i></span></button>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1">
                        <label class="font-bold"> {{ "STUDENT_STATUS" | translate | titlecase }}</label>
                        <select class="form-control custom-select" [(ngModel)]="newStudentStatus">
                            
                            <option [selected]="true"*ngFor="let field of attendanceStatuses" value="{{field.id}}">
                                {{(globals.lang == 'ar')? field.attNameAr : field.attNameEn}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1">
                        <label class="font-bold"> {{ "COMMENT" | translate | titlecase }}</label>
                        <textarea class="form-control" [(ngModel)]="newComment"> </textarea>
                        <!-- <input type="textarea" class="form-control" [(ngModel)]="newComment"> -->

                    </div>
                    <div class="col-md-3 form-group px-md-5 mb-1" style="padding-top: 23px !important;">
                        <button type="button" class="btn btn-success" (click)="updateStudentStatusBulk()"><i
                                class="fas fa-save"></i>{{
                            "UPDATE" | translate | titlecase }}</button>
                    </div>
                </div>
                <br>
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <div style="height: 500px; overflow-y: scroll;">
                        <table *ngIf="students.length >= 1" class="table-striped" data-sticky-header="true" id="datatable">
                            <thead style="position: sticky; top: 0; background: white;">
                                <tr>
                    
                                    <th style="text-align:center"><input type="checkbox" name="select_all" value="1" class="select-all">
                                    </th>
                                    <th>{{ "ID" | translate | titlecase }}</th>
                                    <th>{{ "MAT_NO" | translate | titlecase }}</th>
                                    <th></th>
                    
                                    <th>{{ "DATE" | translate | titlecase }}</th>
                                    <th>{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</th>
                                    <th>{{ "FULL_NAME_ARABIC" | translate | titlecase }}</th>
                                    <th>{{ "GENDER" | translate | titlecase }}</th>
                                    <th>{{ "GROUP" | translate | titlecase }}</th>
                                    <th>{{ "COURSE" | translate | titlecase }}</th>
                                    <th>{{ "COMMENT" | translate | titlecase }}</th>
                                    <th>{{ "ATTENDANCE_STATUS" | translate | titlecase }}</th>
                                    <th>{{ "RECORD_STATUS" | translate | titlecase }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let res of students let i = index">
                                    <td></td>
                                    <td>{{res?.id}}</td>
                                    <td>{{res?.studentid}}</td>
                                    <td>
                                        <img src="{{photoPath+ res.photoFilename}}" onerror="this.src ='assets/images/stud-image.png';"
                                            alt="Photo" class="img-fluid" width="70" id="userImageTag" (load)="getBase64($event, i)"
                                            crossOrigin='Anonymous'>
                                    </td>
                                    <td>{{res?.daydate | date}}</td>
                                    <td>{{res?.fullNameEn}}</td>
                                    <td>{{res?.fullNameAr}}</td>
                                    <td>
                                        {{ res?.gender == "M"? ("MALE" | translate | titlecase) :
                                        ("FEMALE" | translate |
                                        titlecase) }}
                                    </td>
                                    <td>{{(res?.group)? (globals.lang == 'ar')? res?.group?.egroupNameAr + " - (" + (res?.group?.egroupCode)
                                        + ")" : res?.group?.egroupNameEn + " - (" + res?.group?.egroupCode + ")" : ''}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.course?.subjectNameAr :
                                        res?.course?.subjectNameEn}}</td>
                                    <td>{{res?.remarks}}</td>
                                    <td>
                                        {{
                                        (globals.lang == 'ar')? res?.attNameAr : res?.attNameEn
                                        }}
                                    </td>
                                    <td>{{res?.statusFlag}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row" *ngIf="attendanceSummary.length > 0">
                    <div class="card" style="margin: auto;width: 80%;">
                        <div class="card-body">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="3" class="text-center">{{ "ATTENDANCE_SUMMARY" | translate | titlecase }}</th>
                                    </tr>
                                    <tr>
                                        <th>{{ "ATTENDANCE_NAME" | translate | titlecase }}</th>
                                        <th>{{ "ATTENDANCE_CODE" | translate | titlecase }}</th>
                                        <th>{{ "TOTAL_STUDENTS" | translate | titlecase }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let res of attendanceSummary let i = index">
                                        <td>{{(globals.lang == 'ar')? res?.attNameAr : res?.attNameEn}}</td>
                                        <td>{{res?.attCode}}</td>
                                        <td>{{res?.studentsCount}}</td>
                                    </tr>
                                </tbody>
                            </table>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
</div>

<!-- Modal DisableServiceData-->
<div class="modal fade" id="ChronicDiseases" tabindex="-1" aria-labelledby="ChronicDiseases" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <form class="modal-content col-md-12" >
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "VIEW_AVAILABLE_DATES" | translate | titlecase
                    }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <!-- <div class="col-md-2.5 px-md-5 form-group" >
                    <button type="button" class="btn btn-primary" (click)="exportDate()">
                        <span style="font-size: 1.5em; color: white;"><i class="fas fa-file-excel fa-sm"></i></span> {{ "EXPORT" | translate | titlecase }}</button>
                </div> -->
                <div class="row">
                    <div class="col-sm-1">
                        <button (click)="exportDate()" class="btn" style="height:auto"><span
                                style="font-size: 2em; color: green;"><i
                                    class="fas fa-file-excel fa-sm"></i></span></button>
                    </div>
                </div>
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <div style="height: 500px; overflow-y: scroll;">
                        <table class="table-bordered" data-sticky-header="true" id="datetable">
                            <thead style="position: sticky; top: 0; background: white;">
                                <tr>
                                    <th colspan="2" class="text-center">{{ "AVAILABLE_DATES" | translate | titlecase }}</th>
                                </tr>
                                <tr>
                                    <label style="width:200px;">{{ "SEMESTER" | translate | titlecase}}</label>
                                    <label>{{this.searchForm.controls.semester.value}}</label>
                                </tr>
                                <tr>
                                    <label style="width:200px;">{{ "ACADYMIC_YEAR" | translate | titlecase}}</label>
                                    <label>{{searchForm.controls.year.value}}</label>
                                </tr>
                                <tr>
                                    <label style="width:200px;">{{ "BATCH" | translate | titlecase}}</label>
                                    <label>{{this.searchForm.controls.batch.value}}</label>
                                </tr>
                                <tr></tr>
                                <tr>
                                    <th>{{ "DATE" | translate | titlecase }}</th>
                                    <th>{{ "STATUS" | translate | titlecase }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let res of dateStatus let i = index">
                                    <td>{{res?.dateValue}}</td>
                                    <td>{{(res?.dateDescription)? res?.dateDescription.split(' - ')[1] : ''}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            
        </form>
    </div>
</div>